import { render, staticRenderFns } from "./TermsAndConditionsRow.vue?vue&type=template&id=a9a6491e&"
import script from "./TermsAndConditionsRow.ts?vue&type=script&lang=ts&"
export * from "./TermsAndConditionsRow.ts?vue&type=script&lang=ts&"
import style0 from "./TermsAndConditionsRow.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports